// Constants
export const info_aportes = () => {
  return {
    info_aportes: {
      id: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros','archivo_retiros'],        
        type: "number",
        label: "id",
        placeholder: "",
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: true,
          predeterminate: null,
        }
      },
      id_datos_razon: {
        type: "text",
        label: "razon",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "datos_razon",
          label: 'name'
        }
      },
      id_datos_asesor: {
        type: "text",
        label: "Asesor",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: null,
          list: "datos_asesor",
          label: 'name'
        }
      },
      id_descuentos_referido: {
        type: "text",
        label: "referido",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: 0,
        }
      },
      id_list_documento: {
        type: "text",
        label: "Tipo Documento",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_documento",
          label: 'name'
        }
      },
      id_list_forma: {
        type: "text",
        label: "Forma de pago",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_descargar','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 4,
          list: "list_forma",
          label: 'name',
          agregar: true
        }
      },
      id_list_cuentas: {
        type: "text",
        label: "Cuenta",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_descargar','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_cuentas",
          label: 'name',
          agregar: true
        }
      },
      name: {
        type: "text",
        label: "Nombre",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "",
        }
      },
      documento: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        type: 'number',
        label: 'Documento',
        placeholder: '',
        description: 'documento',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: '',
          prepend: '',
          append: '',
        }
      },
      fecha: {
        type: "number",
        label: "fecha",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_descargar','aportes_registros','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "date",
          disabled: false,
          predeterminate: "",
        }
      },
      consignacion: {
        type: "number",
        label: "Fecha cons. ",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_descargar','aportes_registros','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "date",
          disabled: false,
          predeterminate: null,
        }
      },
      direccion: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        type: 'text',
        label: 'Dirección',
        placeholder: '',
        description: 'Dirección',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }
      },
      email: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        type: 'text',
        label: 'Email',
        placeholder: '',
        description: 'Email',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }
      },
      telefonos: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        type: 'text',
        label: 'Teléfonos',
        placeholder: '',
        description: 'Telefonos',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }
      },
      descripcion: {
        type: "text",
        label: "Descripcion",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "Aportes en seguridad social",
        }
      },
      valor: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        type: 'number',
        label: 'Valor',
        placeholder: '',
        description: 'Valor',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      reporte: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        type: 'number',
        label: 'Reporte',
        placeholder: '',
        description: 'Reporte',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      comision: {
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        type: 'number',
        label: 'Comisión',
        placeholder: '',
        description: 'Valor',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      consecutivo: {
        type: "number",
        label: "Consecutivo",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: 0,
        }
      },    
      id_list_mes: {
        type: "number",
        label: "Mes periodo",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_mes",
          label: 'name'
        }
      },   
      id_list_ano: {
        type: "number",
        label: "Ano periodo",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 2020,
          list: "list_ano",
          label: 'name'
        }
      },   
      label_consecutivo: {
        type: "text",
        label: "Consecutivo",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "APORTE Nº",
        }
      },    
      tipo: {
        type: "number",
        label: "tipo",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: 0,
        }
      },  
      anulado: {
        type: "number",
        label: "tipo",
        placeholder: "",
        namepath: ['afiliacion_registros','afiliacion_informes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "price",
          disabled: false,
          predeterminate: 0,
        }
      },  
      observacion: {
        type: "text",
        label: "Observaciones",
        placeholder: "",
        namepath: ['aportes_registrar','servicios_aportes','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "textarea",
          disabled: false,
          predeterminate: '- NO ES VALIDO PARA PRESENTAR EN LA E.P.S. \r - SEGÚN EL DECRETO 806 DE ABRIL DE 1998 LOS PAGOS SE DEBEN REALIZAR LOS 5 PRIMEROS DÍAS HÁBILES DE CADA MES, PARA EVITAR INTERESES POR MORA, SUSPENSIÓN EN EL SERVICIO Y PERDER EL DERECHO A INCAPACIDAD.  \r - EL RETIRO DEBE REALIZARSE CON 30 DÍAS DE ANTICIPACIÓN',
          rows: 5
        }
      },
      servicios: {
        type: "boolean",
        label: "Solo servicios",
        placeholder: "",
        namepath: ['servicios_registrar','aportes_registros'],
        description: "",
        validate: "",
        datatype: {
          type: "check",
          disabled: false,
          predeterminate:0,
        }
      },    
      nota_delete: {
        type: "text",
        label: "Nota",
        placeholder: "",
        namepath: ['afiliacion_registros'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      }, 
    }
  }
}


